import { useState, type KeyboardEvent } from 'react';
import { SampleLabel } from './SampleLabel';

function ChevronLeftIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M15 18l-6-6 6-6" />
    </svg>
  );
}

function ChevronRightIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M9 18l6-6-6-6" />
    </svg>
  );
}

export function BeforeAfterPair({
  before,
  after,
  beforeAlt,
  afterAlt,
  beforeLabel,
  afterLabel,
  sampleLabel,
}: {
  before: string;
  after: string;
  beforeAlt: string;
  afterAlt: string;
  beforeLabel: string;
  afterLabel: string;
  sampleLabel: string;
}) {
  const [pos, setPos] = useState(50);

  const onKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    const step = event.shiftKey ? 10 : 2;
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      setPos((p) => Math.max(0, p - step));
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      setPos((p) => Math.min(100, p + step));
    }
  };

  return (
    <figure className="comparison-figure">
      <div className="plate comparison-slider" data-component="comparison-slider">
        <div className="comparison-frame aspect-plate">
          <img
            src={after}
            alt={afterAlt}
            loading="lazy"
            decoding="async"
            className="comparison-img"
          />
          <div
            className="comparison-before"
            style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
          >
            <img
              src={before}
              alt={beforeAlt}
              loading="lazy"
              decoding="async"
              className="comparison-img comparison-img-static"
            />
          </div>
        </div>

        <div
          className="comparison-divider"
          style={{ left: `${pos}%` }}
          aria-hidden="true"
        />

        <input
          type="range"
          min={0}
          max={100}
          value={pos}
          onChange={(e) => setPos(Number(e.target.value))}
          onKeyDown={onKeyDown}
          aria-label={`${beforeLabel} / ${afterLabel}`}
          className="comparison-range"
        />

        <div
          className="comparison-handle elev-1"
          style={{ left: `${pos}%` }}
          aria-hidden="true"
        >
          <span className="comparison-handle-icon text-ink-secondary">
            <ChevronLeftIcon />
          </span>
          <span className="comparison-handle-icon text-ink-secondary">
            <ChevronRightIcon />
          </span>
        </div>
      </div>

      <figcaption className="comparison-caption">
        <SampleLabel>{sampleLabel}</SampleLabel>
        <span className="type-label-sm text-ink-muted">
          {beforeLabel} <span aria-hidden="true">/</span> {afterLabel}
        </span>
      </figcaption>
    </figure>
  );
}
